import type { ClassValue } from 'clsx'

import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// The custom type scale (text-display, text-h1, ...) is a font size, not a color.
// Without this, tailwind-merge treats it as a color and drops it next to text-ink.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: ['display', 'h1', 'h2', 'h3', 'lead'] }]
        }
    }
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
